angular.module('unica_partner.partner_controllers')

.controller('PartnerListController', function(
	$rootScope, $scope, $state,
	$confirm,
	PartnerListService, PartnerDeleteService
) {
	$scope.partnerList = [];
	$scope.limit  = 10;
	$scope.offset = 0;
	$scope.canLoad = true;

	$scope.loadPartners = function() {
		$scope.showLoader();
		$scope.canLoad = false;
		PartnerListService
			.list($scope.limit, $scope.offset)
			.then(function(data) {
				$scope.hideLoader();

				if (!data.error) {
					$scope.partnerList = $scope.partnerList.concat( data );
					if ( data.length == 0 ) {
						$scope.canLoad = false;
					} else {
						$scope.canLoad = true;
						$scope.offset = $scope.offset + data.length;
					}
				} else {
					$rootScope.manageError(data);
				}
			});
	};

	$scope.loadPartners();

	$scope.deletePartner = function(partnerId) {
		$confirm({
			title: 'Sei sicuro di voler eliminare il partner?',
			text: 'Confermi la cancellazione del partner?'
		}).then(function() {

			$scope.showLoader();
			PartnerDeleteService
				.delete( partnerId )
				.then(function(data) {
					$scope.hideLoader();

					if (!data.error) {
						angular.forEach($scope.partnerList, function(partner, key) {
							if ( partner.id == partnerId ) {
								$scope.partnerList.splice(key, 1);
							}
						});
						$scope.showSuccessMsg('Partner eliminato con successo!', '');
					} else {
						$rootScope.manageError(data);
					}

				});

		}, function() {
			// Cancel
		});
	};

})

;